module.exports = __webpack_public_path__ + "img/air-jordan-xxxvi.b749f2e6.png";